export const constants = {
    // host: 'https://localhost:44314/',
    // host: 'https://api.goldtechnic.net/',
    host: 'https://api.goldtechnic.ir/',
    connectionName: 'G-Tech',
    userName: '',
    password: '',
};